/**
 * Texts for Reviews page
 */
export const reviewsPage = {
    title: 'Histórias - CamAPS FX',
    titleMeta: 'Leia as histórias de utilizadores do CamAPS FX',
    descriptionMeta: 'O CamAPS FX transforma a vida de muitos utilizadores, proporcionando um controlo da glicose sem precedentes e reduzindo o impacto da diabetes nos utilizadores e nas suas famílias.',
    keywords:
        'histórias camaps, histórias camaps fx, ' +
        '',
    localeMeta: 'pt_PT',

    shortReview1:
        '<h2>"Queríamos apenas dizer-lhe o quanto a vida da nossa filha e as nossas vidas melhoraram ' +
        'desde que ela passou a utilizar o sistema de circuito fechado CamAPS FX." </h2>' +
        '<p>' +
        '    <span>Pais de uma adolescente</span>' +
        '</p>',

    shortReview2:
        '<p> ' +
        '   É impossível exagerar o quanto isto mudou as nossas vidas. Como por magia, ' +
        '   quase todos esses problemas desaparecem, ou seja, o esgotamento devido às noites interrompidas, ' +
        '   a verificação constante durante o dia. Não é exagero dizer ' +
        '   que o CamAPS FX nos devolveu a vida. Sim, ainda temos de contar hidratos de carbono, ' +
        '   sim, administramos um bólus 10 minutos antes das refeições e sim, temos de mudar as cânulas da bomba, mas é só isso. ' +
        '   O CamAPS FX dá-nos a liberdade de nos esquecermos da diabetes durante a maior parte do dia.' +
        '</p> ' +
        '    <p> ' +
        '        <span>David, pai de uma menina de 9 anos</span> ' +
        '    </p>',
    shortReview3:
        '<h2>Obrigado. A noite passada foi a melhor noite de sono que tive há muito tempo.</h2>' +
        '<p>' +
        '    <span>Utilizador adulto com mais de 60 anos</span>' +
        '</p>',

    shortReview4:
        '<p> ' +
        'No geral, notámos o efeito na vida do nosso filho: teve uma melhoria significativa ' +
        'no desenvolvimento da marcha e da fala. Fez uma enorme diferença ' +
        'nestes últimos meses. O meu filho tem estado muito mais confiante, ' +
        'menos irritado e, de um modo geral, mais feliz.' +
        '    </p> ' +
        '    <p> ' +
        '        <span>Mãe de uma criança pequena</span> ' +
        '    </p>',


};
